<div (click)="executeItem()" class="custom-dropdown-item disableable" [class.item-disabled]="disabled" 
    [class.custom-dropdown-item-highlight]="isHighlighted" (mouseenter)="toggleHighlight()" (mouseleave)="toggleHighlight()">
    <div class="custom-dropdown-item-content">
        <img [src]="iconPath" class="custom-dropdown-icon" [class.icon-disabled]="disabled">
        <span>{{name}}</span>
    </div>
</div>